export default "__VITE_ASSET__BpJVsMFX__"